import ReservationReview from "../Components/ReservationReview"

export const DayCampPageOptions = {
   WeekSelection: "Week Selection",
   PesonalInfo: "Personal Information",
   MedicalInsurance: "Medical and Insurance Information",
   DayCampOptions: "Day Camp Options",
   ParentConsent: "Parent Consent",
   Review: "Review",
   Payment: "Payment",
   PaymentCashCheck: "PaymentCashCheck"
}

export const CombinationPageOptions = {
   WeekSelection: "Week Selection",
   PersonalInfo: "Personal Information",
   MedicalInsurance: "Medical and Insurance Information",
   JoinGroup: "Join Group",
   CamperType: "Camper Type",
   Disclaimer: "Disclaimer",
   Review: "Review",
   Payment: "Payment"
}

export const GroupPageOptions = {
   WeekSelection: "Week Selection",
   ReservationTypeSelection: "Reservation Type Selection",
   ReservationSpotSelection: "Reservation Spot Selection",
   Review: "Reservation Review",
   ReservationPayment: "Reservation Payment",
}

export const RetreatPageOptions = {
   WeekSelection: "Week Selection",
   PersonalInfo: "Personal Information",
   MedicalInsurance: "Medical and Insurance Information",
   AdditionalDetails: "Additional Details",
   JoinGroup: "Join Group",
   Disclaimer: "Disclaimer",
   Review: "Review",
   Payment: "Payment"
}

export const FamilyCampPageOptions = {
   WeekSelection: "Week Selection",
   TierSelection: "Tier Selection",
   PersonalInfo: "Personal Information",
   MedicalInsurance: "Medical and Insurance Information",
   Disclaimer: "Disclaimer",
   Review: "Review",
}

export const RetreatGroupPageOptions = {
   WeekSelection: "Week Selection",
   ReservationTypeSelection: "Reservation Type Selection",
   ReservationSpotSelection: "Reservation Spot Selection",
   Review: "Reservation Review",
   ReservationPayment: "Reservation Payment",
}

